module.exports = __webpack_public_path__ + "static/media/home-feeling-better3.f94be20d.svg";